// extracted by mini-css-extract-plugin
export default {"Wrapper":"RedBar_Wrapper__OgQw7"};